import { CheckboxContainer } from './CheckboxContainer';
import React, { useState } from 'react';

/**
 * Component for organization autocompletes
 * @param organizations the organizations that will be filtered through
 * @param data the orgData
 * @param setData setter for orgData
 * @param type the type of data we're dealing with
 *      'editOrganization' for EditOrganization.jsx
 *      'newArticle' for NewArticle.jsx
 */
export const OrganizationAutocomplete = ({
	organizations,
	data,
	setData,
	type,
}) => {
	let partnerIndex = -1;
	const [partnerAutocomplete, setPartnerAutocomplete] = useState([]);
	const [pageRefresh, setPageRefresh] = useState(false);

	/**
	 * Creates an array with valid autocomplete values, given the input value
	 * @param input the input to find autocomplete values for
	 * @return {*[]|*} an array with all values that match the input
	 */
	const autocompleteMatch = (input) => {
		let element = document.getElementById(
			'partners-autocomplete-results-container'
		);

		if (input.length < 2) {
			if (element.classList.contains('active')) {
				element.classList.remove('active');
			}
			return [];
		}

		let reg = new RegExp(input.toLowerCase());
		let filter = organizations.filter((term) => {
			if (term[1].toLowerCase().match(reg)) {
				return term;
			}
		});

		// If there are autocomplete contents, then display them
		if (filter.length > 0) {
			if (!element.classList.contains('active')) {
				element.classList.add('active');
			}
		}
		return filter;
	};

	/**
	 * Called when a sponsorship partner from the dropdown is called
	 * @param index the current index, to update partnerIndex
	 */
	const handleClickPartner = (index) => {
		partnerIndex = index;
		addPartner();
	};

	/**
	 * Updates the results for sponsorship partners autocomplete
	 * @param event the event
	 */
	const updateResultsForSponsorshipPartnershipsAutocomplete = (event) => {
		let terms = autocompleteMatch(event.target.value);

		let tempAutocomplete = [];
		for (let i = 0; i < terms.length; i++) {
			tempAutocomplete.push(terms[i]);
		}

		setPartnerAutocomplete(tempAutocomplete);
	};

	/**
	 * Adds a partner to data and resets the autocomplete list
	 */
	const addPartner = () => {
		let selectedPartner = partnerAutocomplete[partnerIndex];
		let found = false;
		let formattedSelectedPartner;
		let dataTypeAttribute;

		if (type === 'NewArticle') {
			formattedSelectedPartner = {
				id: selectedPartner[0],
				name: selectedPartner[1],
			};
			for (const partner of data.organization_ids) {
				if (String(selectedPartner.id) === String(partner.id)) {
					found = true;
				}
			}
			dataTypeAttribute = 'organization_ids';
		} else {
			formattedSelectedPartner = {
				id: selectedPartner[0],
				name: selectedPartner[1],
			};
			for (const partner of data.partners) {
				if (String(selectedPartner[0]) === String(partner.id)) {
					found = true;
				}
			}
			dataTypeAttribute = 'partners';
		}

		if (!found) {
			data[dataTypeAttribute].push(formattedSelectedPartner);
			setData(data);
			console.log(data);
		}

		// Reset autocomplete list
		setPartnerAutocomplete([]);
		document.getElementById('partners-sponsorship').value = '';
		partnerIndex = -1;

		let element = document.getElementById(
			'partners-autocomplete-results-container'
		);
		if (element.classList.contains('active')) {
			element.classList.remove('active');
		}
	};

	/**
	 * Handles a key press for partner autocomplete
	 * @param event the key press event
	 */
	const handleKeyPressForSponsorshipPartnerAutocomplete = (event) => {
		let length = partnerAutocomplete.length;

		if (event.keyCode === 13) {
			// Enter
			// Add the selected one to orgData, unless it's -1 or out of range
			if (partnerIndex > -1 && partnerIndex < length) {
				addPartner();
			}
		} else {
			if (event.keyCode === 38) {
				// Up Arrow
				event.preventDefault();
				partnerIndex =
					(((partnerIndex - 1) % length) + length) % length;
				resetTagsAndAssignNew();
			} else if (event.keyCode === 40) {
				// Down Arrow
				event.preventDefault();
				partnerIndex =
					(((partnerIndex + 1) % length) + length) % length;
				resetTagsAndAssignNew();
			}
		}
	};

	/**
	 * Removes a sponsorship partner
	 * @param e not needed
	 * @param tagPrefix not needed
	 * @param id the id of the partner
	 */
	const handleRemoveSponsorshipPartner = (e, tagPrefix, id) => {
		if (type === 'NewArticle') {
			for (const partner of data.organization_ids) {
				if (String(partner.id) === String(id)) {
					data.organization_ids.splice(
						data.organization_ids.indexOf(partner),
						1
					);
					break;
				}
			}
		} else {
			for (const partner of data.partners) {
				if (String(partner.id) === String(id)) {
					data.partners.splice(data.partners.indexOf(partner), 1);
					break;
				}
			}
		}

		setData(data);
		console.log(data);
		setPageRefresh(!pageRefresh);
	};

	/**
	 * Rests all current tags, and adds the selected tag to active pool
	 */
	const resetTagsAndAssignNew = () => {
		let activeTags = document.getElementsByClassName('active-partner-tag');

		// Remove all current active tags first, then assign the new one
		for (const tag of activeTags) {
			tag.classList.remove('active-partner-tag');
		}
		let element = document.getElementById('partner-tag-' + partnerIndex);
		element.classList.add('active-partner-tag');
		let elementTop = element.offsetTop;
		let elementBottom = element.offsetTop + element.offsetHeight;
		let screenTop = window.scrollY;
		let screenHeight = window.innerHeight;
		let bottomScreenY = screenTop + screenHeight;
		if (elementTop <= screenTop || elementBottom >= bottomScreenY) {
			element.scrollIntoView({
				behavior: 'smooth',
				block: 'nearest',
				inline: 'nearest',
			});
		}
	};

	console.log(partnerAutocomplete);
	return (
		<div className="organization-autocomplete-container">
			<input
				type="text"
				name="partners-sponsorship"
				id="partners-sponsorship"
				onChange={(event) =>
					updateResultsForSponsorshipPartnershipsAutocomplete(event)
				}
				className="body-font-important"
				placeholder="Enter an organization"
				onKeyDown={(event) =>
					handleKeyPressForSponsorshipPartnerAutocomplete(event)
				}
			/>
			<div id="partners-autocomplete-results-container">
				{partnerAutocomplete.map((partner, index) => {
					return (
						<li
							className="partner-tag body-font"
							id={'partner-tag-' + index}
							key={partner[0]}
							value={partner[1]}
							onClick={() => handleClickPartner(index, partner)}
						>
							<p>{partner[1]}</p>
						</li>
					);
				})}
			</div>
			<CheckboxContainer
				orgID={data.id}
				handleCheckboxes={handleRemoveSponsorshipPartner}
				data={
					type === 'NewArticle'
						? data.organization_ids
						: data.partners
				}
				isCheckboxDefaultChecked={null}
				tagPrefix="partners"
			/>
		</div>
	);
};
